var NAMESPACE = 'td';

var Tabs = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-tabs" }, [_c('div', { staticClass: "td-tabs__title", class: _vm.customTitleClass }, [_c('div', { staticClass: "td-tabs__nav" }, _vm._l(_vm.tabs, function (tab) {
      return _c('div', { key: tab.key, staticClass: "td-tabs__item", class: { 'is-active': tab.key === _vm.activeKey }, on: { "click": function click($event) {
            return _vm.handleTitleClick(tab);
          }, "mousedown": function mousedown($event) {
            return _vm.handleTitleClick(tab, true);
          } } }, [_vm._t("title", [_vm._v(_vm._s(tab.title))], { "tab": tab })], 2);
    }), 0), _vm._v(" "), _c('div', { staticClass: "td-tabs__extra" }, [_vm._t("extra")], 2)]), _vm._v(" "), _c('div', { staticClass: "td-tabs__content" }, [_c('div', { staticClass: "td-tabs__prepend" }, [_vm._t("prepend")], 2), _vm._v(" "), _vm._l(_vm.tabs, function (tab) {
      return tab.key === _vm.activeKey ? _c('div', { key: tab.key, staticClass: "td-tabs__pane" }, [_vm._t("default", null, { "tab": tab })], 2) : _vm._e();
    })], 2)]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-tabs',

  props: {
    tabs: Array,
    activeKey: null,
    customTitleClass: String,
    triggerChangeTabByMouseDown: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    handleTitleClick: function handleTitleClick(tab) {
      var isMouseDownEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.triggerChangeTabByMouseDown === isMouseDownEvent) {
        this.$emit('update:activeKey', tab.key);
      }
    }
  }
};

Tabs.install = function (Vue) {
  Vue.component(Tabs.name, Tabs);
};

export default Tabs;
